import React from 'react';
import { FormattedMessage } from 'react-intl';

export const Footer = () => {
    return (
        <footer className="container-fluid">
            <div className="row">
                <div className="col">
                    <ul className="nav">
                        <li className="nav-item">
                            <a href="https://www.gefuehlsmonster.de/kontakt/" className="nav-link" target="_blank" rel="noopener noreferrer">
                                <FormattedMessage id="footer.link.contact" />
                            </a>
                        </li>
                        <li className="nav-item">
                            <a href="https://www.gefuehlsmonster.de/impressum/" className="nav-link" target="_blank" rel="noopener noreferrer">
                                <FormattedMessage id="footer.link.imprint" />
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="col text-right">
                    <FormattedMessage id="footer.serviceCopyLine" />{' '}
                    <a href="https://www.gefuehlsmonster.de/" target="_blank" rel="noopener noreferrer">
                        <FormattedMessage id="company" />
                    </a>
                </div>
            </div>
        </footer>
    );
};